module.exports = __webpack_public_path__ + "site/img/index1zh11.f7e7af54.png";